import React, { useEffect } from "react"
import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import Grid from "@mui/material/Grid"
import Hidden from "@mui/material/Hidden"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TablePagination from "@mui/material/TablePagination"
import TableRow from "@mui/material/TableRow"
import { EstilosButton, InventarioStyles } from "../utils/styles"
import SelectFormat from "../components/SelectFormat"
import Input from "../components/Input"
import { BsSearch } from "react-icons/bs"
import { useState } from "react"
import { NavLink } from "react-router-dom"
import servo from "../services/servo"
import { AiOutlineReload } from "react-icons/ai"
import { useLocalStorage } from "../hooks/useLocalStorage"
import { Alert, CircularProgress, IconButton, Switch } from "@mui/material"
import { Button } from "@mui/material"
import { BiPlus } from "react-icons/bi"
import Acciones from "./Acciones"
import CarTablePDF from ".././components/carTable"
import { useGetDatos } from "../hooks/useGetDatos"
import TableExcel from "./TableExcel"

let VS = InventarioStyles()
let VS2 = EstilosButton()
export default function StickyHeadTable({
  seeDisabledOption = true,
  Actions = true,
  buscador,
  filtersDefault = true,
  expand = "",
  busqueda = {},
  permisoCheck,
  dataTable,
  tipo,
  nombreBusqueda,
  setBusqueda,
  filtroCustom = false,
  dataPdf,
  addLabel,
  serverPagination = false,
  serverFilters = {}
}) {
  let EstilosButton = VS2()
  let InventarioStyles = VS()

  const [totalRows, setTotalRows] = useState(0)
  const [exportData, setExportData] = useState(null)
  const [exportLoading, setExportLoading] = useState(false)
  const requestId = React.useRef(0)
  const activeRequest = React.useRef(null)
  const filterKey = JSON.stringify({ busqueda, serverFilters })
  const previousFilters = React.useRef(null)
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [showHabilit, setShowHabilit] = useState(false)
  const [datos, setDatos] = useState(null)
  const { reload, setReload } = useGetDatos()
  const [loading, setLoading] = useState(false)
  const [requestError, setRequestError] = useState("")
  const [permiso] = useLocalStorage("permiso", null)
  const [datosHabilitados, setDatosHabilitados] = useState(null)
  const [datosDeshabilitados, setDatosDeshabilitados] = useState(null)
  const puedeCrear =
    (permiso?.[permisoCheck] & 2) === 2 ||
    (permisoCheck === "carrosAreas" &&
      (((permiso?.areas & 2) === 2) || ((permiso?.carros & 2) === 2)))

  const busquedaPaginacion = {
    ver: "",
    nombre: ""
  }

  const [verBusqueda, setVerBusqueda] = useState({ ...busquedaPaginacion })

  const camelToKebab = (str) => {
    return str.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`)
  }

  const getDefaultDates = () => {
    const today = new Date()
    const startOfYear = new Date(today.getFullYear(), 0, 1)
    return {
      inicio: startOfYear.toISOString().split("T")[0],
      final: today.toISOString().split("T")[0]
    }
  }

  const serverQuery = (targetPage = page) => {
    const params = new URLSearchParams({
      expand, paginado: "1", page: String(targetPage + 1),
      pageSize: String(rowsPerPage), deshabilitados: showHabilit ? "1" : "0"
    })
    Object.entries({ ...busqueda, ...serverFilters }).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") params.set(key, value)
    })
    return params.toString()
  }

  const prepareExport = async () => {
    const currentRequest = requestId.current
    setExportLoading(true)
    try {
      const res = await servo.get(camelToKebab(permisoCheck) + "?" + serverQuery(0) + "&exportar=1")
      if (currentRequest !== requestId.current) return
      if (!Array.isArray(res?.cuerpo?.resultado)) throw new Error("No fue posible preparar la exportación.")
      setExportData(res.cuerpo.resultado)
    } catch (error) {
      if (currentRequest === requestId.current) setRequestError(error.message)
    } finally {
      setExportLoading(false)
    }
  }

  const getDatos = async (fechas = null, textoBuscar = null, targetPage = page) => {
    if (serverPagination) {
      // Los cambios de fecha se consultan desde el efecto con el estado actualizado.
      if (fechas !== null) return
      activeRequest.current?.abort()
      const controller = new AbortController()
      activeRequest.current = controller
      const currentRequest = ++requestId.current
      let timedOut = false
      const timeout = setTimeout(() => { timedOut = true; controller.abort() }, 20000)
      setLoading(true)
      setRequestError("")
      setExportData(null)
      try {
        const res = await servo.get(camelToKebab(permisoCheck) + "?" + serverQuery(targetPage), true, { signal: controller.signal })
        if (currentRequest !== requestId.current) return
        if (!Array.isArray(res?.cuerpo?.resultado)) throw new Error("No fue posible cargar los checklists.")
        const data = res.cuerpo.resultado
        setDatos(data)
        setDatosHabilitados(data)
        setDatosDeshabilitados(data)
        setTotalRows(Number(res.cuerpo.paginacion.total))
        setPage(Number(res.cuerpo.paginacion.page) - 1)
      } catch (error) {
        if (currentRequest !== requestId.current) return
        if (error.name === "AbortError" && !timedOut) return
        setRequestError(timedOut
          ? "La consulta excedió 20 segundos. Puedes cambiar los filtros o pulsar recargar para reintentar."
          : error.message)
        setDatos([])
        setDatosHabilitados([])
        setDatosDeshabilitados([])
        setTotalRows(0)
      } finally {
        clearTimeout(timeout)
        if (currentRequest === requestId.current) setLoading(false)
      }
      return
    }
    setLoading(true)
    setRequestError("")

    const kebabPermisoCheck = camelToKebab(permisoCheck)

    let queryParams = [`expand=${expand}`]

    const { fechaInicio, fechaFinal, ...otrosFiltrosDeBusqueda } = busqueda

    const hayOtrosFiltrosActivos = Object.values(otrosFiltrosDeBusqueda).some(
      (val) => val !== null && val !== undefined && val !== ""
    )

    const fechaSeleccionadaPorUsuario =
      (fechaInicio !== null && fechaInicio !== "") ||
      (fechaFinal !== null && fechaFinal !== "")

    let rangoDeFechasParaAPI = { inicio: null, final: null }

    if (fechas !== null && (fechas.fechaInicio || fechas.fechaFinal)) {
      rangoDeFechasParaAPI.inicio = fechas.fechaInicio
      rangoDeFechasParaAPI.final = fechas.fechaFinal
    } else if (fechaSeleccionadaPorUsuario) {
      rangoDeFechasParaAPI.inicio = fechaInicio
      rangoDeFechasParaAPI.final = fechaFinal
    } else if (!hayOtrosFiltrosActivos && !filtroCustom) {
      const defaultDates = getDefaultDates()
      rangoDeFechasParaAPI.inicio = defaultDates.inicio
      rangoDeFechasParaAPI.final = defaultDates.final
    }

    if (rangoDeFechasParaAPI.inicio) {
      queryParams.push(`fecha-inicio=${rangoDeFechasParaAPI.inicio}`)
    }
    if (rangoDeFechasParaAPI.final) {
      queryParams.push(`fecha-final=${rangoDeFechasParaAPI.final}`)
    }

    // --- NUEVO CÓDIGO A AGREGAR ---
    // Tomamos el texto a buscar y lo enviamos al backend (PHP)
    let valorBusqueda = textoBuscar !== null ? textoBuscar : (verBusqueda?.nombre || "");
    if (valorBusqueda.trim() !== "") {
      // Si es array mandamos "terminoGeneral", si no, mandamos el nombre exacto de la columna
      const nombreParametro = Array.isArray(nombreBusqueda) ? "terminoGeneral" : nombreBusqueda;
      queryParams.push(`${nombreParametro}=${encodeURIComponent(valorBusqueda.trim())}`);
    }
    // ------------------------------

    const finalUrl = `${kebabPermisoCheck}?${queryParams.join("&")}`

    try {
      const res = await servo.get(finalUrl)
      const data = res?.cuerpo?.resultado

      if (!Array.isArray(data)) {
        const unauthorized = res?.status === 401 || res?.code === 0
        setRequestError(
          unauthorized
            ? "Tu sesión no pudo validarse. Actualiza la página o vuelve a iniciar sesión."
            : res?.message || "No fue posible cargar la información del módulo."
        )
        setDatos([])
        setDatosHabilitados([])
        setDatosDeshabilitados([])
        return
      }

      setDatos(data)
      setDatosHabilitados(
        data.filter((dato) => dato.eliminado === null)
      )
      setDatosDeshabilitados(
        data.filter((dato) => dato.eliminado !== null)
      )
    } catch (error) {
      setRequestError(
        error?.message || "No fue posible conectar con el servidor."
      )
      setDatos([])
      setDatosHabilitados([])
      setDatosDeshabilitados([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!serverPagination) getDatos()
  }, [])

  useEffect(() => {
    if (!serverPagination) return
    const key = filterKey + showHabilit
    const changed = previousFilters.current !== key
    previousFilters.current = key
    if (changed && page !== 0) {
      setPage(0)
      return
    }
    getDatos(null, null, page)
    return () => {
      requestId.current += 1
      activeRequest.current?.abort()
    }
  }, [serverPagination, filterKey, showHabilit, page, rowsPerPage])

  useEffect(() => {
    if (reload) {
      getDatos()
      setReload(false)
    }
  }, [reload])

  const filterData = (datosParaFiltrar) => {
    if (serverPagination) return datosParaFiltrar || []
    if (!datosParaFiltrar || datosParaFiltrar.length === 0) {
      return [] // Si no hay datos para filtrar, retorna un arreglo vacío
    }

    let datosFiltrados = [...datosParaFiltrar]

    const normalizeDate = (date) => {
      const fechaUTC = new Date(date)
      const localDate = new Date(
        fechaUTC.toLocaleString("en-US", { timeZone: "America/Phoenix" })
      )

      return new Date(
        localDate.getFullYear(),
        localDate.getMonth(),
        localDate.getDate()
      )
    }

    const { fechaInicio, fechaFinal, ...otrosFiltrosDeBusqueda } = busqueda

    const hayOtrosFiltrosActivos = Object.values(otrosFiltrosDeBusqueda).some(
      (val) => val !== null && val !== undefined && val !== ""
    )

    const fechaSeleccionadaPorUsuario =
      (fechaInicio !== null && fechaInicio !== "") ||
      (fechaFinal !== null && fechaFinal !== "")

    let rangoDeFechasAUsar = { inicio: null, final: null }

    // NUEVO: Verificamos si el usuario escribió algo en el buscador
    const isBusquedaEspecifica = verBusqueda?.nombre && verBusqueda.nombre.trim() !== ""

    if (fechaSeleccionadaPorUsuario) {
      rangoDeFechasAUsar.inicio = fechaInicio
      rangoDeFechasAUsar.final = fechaFinal
    } else if (!hayOtrosFiltrosActivos && !filtroCustom) {
      const defaultDates = getDefaultDates()
      rangoDeFechasAUsar.inicio = defaultDates.inicio
      rangoDeFechasAUsar.final = defaultDates.final
    }

    // MODIFICADO: Solo filtramos por fecha si NO hay una búsqueda específica activa
    if (!isBusquedaEspecifica && (rangoDeFechasAUsar.inicio || rangoDeFechasAUsar.final)) {
      datosFiltrados = datosFiltrados.filter((d) => {
        const fechaDato = normalizeDate(d.creado)

        const inicio = rangoDeFechasAUsar.inicio
          ? normalizeDate(new Date(`${rangoDeFechasAUsar.inicio}T00:00:00`))
          : null

        const final = rangoDeFechasAUsar.final
          ? normalizeDate(new Date(`${rangoDeFechasAUsar.final}T23:59:59`))
          : null

        return (
          (!inicio || fechaDato >= inicio) && (!final || fechaDato <= final)
        )
      })
    }

    if (filtroCustom) {
      datosFiltrados = datosFiltrados.filter(filtroCustom)
    }

    Object.keys(otrosFiltrosDeBusqueda).forEach((k) => {
      // Iteramos solo sobre los 'otrosFiltrosDeBusqueda'
      if (
        otrosFiltrosDeBusqueda[k] !== "" &&
        otrosFiltrosDeBusqueda[k] !== null &&
        otrosFiltrosDeBusqueda[k] !== undefined
      ) {
        datosFiltrados = datosFiltrados.filter((d) => {
          const valor = d[k]
          const criterio = otrosFiltrosDeBusqueda[k]

          if (typeof valor === "string") {
            return valor.toLowerCase().includes(criterio.toLowerCase())
          } else if (typeof valor === "number") {
            return valor === parseFloat(criterio)
          }
          return false
        })
      }
    })

    return datosFiltrados
  }

  const filtrar = (nombre, data, busquedaState, filtroCustomState) => {
    if (serverPagination) return data || []
    let dataResult = []
    if (!nombre) {
      dataResult = data
    } else {
      dataResult = data.filter((datos) => {
        // Si nombreBusqueda es un arreglo de varios campos
        if (Array.isArray(nombreBusqueda)) {
          return nombreBusqueda.some((campo) =>
            campo
              .split(".")
              .reduce((objeto, propiedad) => objeto?.[propiedad], datos)
              ?.toString()
              .toLowerCase()
              .includes(nombre.toLowerCase())
          );
        }
        // Si es un solo string (comportamiento original)
        return datos[nombreBusqueda]?.toString().toLowerCase().includes(nombre.toLowerCase());
      })
    }
    return filterData(dataResult, busquedaState, filtroCustomState)
  }

  // function toTitleCase(str) {
  //   return str.replace(/\w\S*/g, function (txt) {
  //     return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  //   })
  // }

  //MOSTRAR O NO DESHABILITADOS
  const handleChange = () => {
    if (showHabilit === true) {
      setShowHabilit(false)
    } else {
      setShowHabilit(true)
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  return (
    <>
      <div className={InventarioStyles.tableContainer}>
        <div>
          {/* CONTENEDOR DE FILTROS */}
          {filtersDefault ? (
            <Grid container className={InventarioStyles.filterContainer}>
              {/* CONTENEDOR DEL INPUT BUSCADOR */}
              {!filtroCustom && (
                <Grid
                  item
                  xs={12}
                  sm={7}
                  md={5}
                  sx={{
                    "@media (max-width: 600px)": {
                      marginTop: "12px",
                      order: "2"
                    },
                    "@media (min-width: 600px)": {
                      order: "1",
                      marginTop: "0px",
                      paddingRight: "10px"
                    },
                    "@media (min-width: 900px)": {
                      // height:"41px",
                      marginTop: "0px",
                      order: "2"
                    }
                  }}
                >
                  <Input
                    typeInput={"search"}
                    valor={verBusqueda?.nombre}
                    onChange={(e) =>
                      setVerBusqueda({
                        ...verBusqueda,
                        nombre: e.target.value
                      })
                    }
                    placeholder="Buscar"
                    nombreBusqueda={
                      Array.isArray(nombreBusqueda)
                        ? "por " + nombreBusqueda.map((campo) =>
                          campo.replace(/([A-Z])/g, " $1").charAt(0).toUpperCase() +
                          campo.replace(/([A-Z])/g, " $1").slice(1)
                        ).join(", ")
                        : nombreBusqueda
                          .replace(/([A-Z])/g, " $1")
                          .charAt(0)
                          .toUpperCase() +
                        nombreBusqueda.replace(/([A-Z])/g, " $1").slice(1)
                    }
                    Icon={BsSearch}
                    IconStyle={{
                      width: "20px",
                      height: "17px",
                      color: "#157CC1"
                    }}
                  />
                </Grid>
              )}

              {/* CONTENEDOR DEL BOTON DE AGREGAR  */}
              <Grid
                item
                xs={10}
                sm={filtroCustom != false ? 10 : 4}
                md={2}
                sx={{
                  "@media (max-width: 600px)": {
                    order: "1"
                  },
                  "@media (min-width: 600px)": {
                    order: "2"
                  },
                  "@media (min-width: 900px)": {
                    order: "3"
                  }
                }}
              >
                {puedeCrear ? (
                  <div
                    style={{
                      width: "100%",
                      height: "41px"
                    }}
                  >
                    <NavLink
                      exact
                      to={"/" + permisoCheck + "/crear"}
                      className={InventarioStyles.navStyle}
                    >
                      <Button
                        sx={{
                          width: "100%",
                          height: "41px",
                          backgroundColor: "#157CC1",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          textTransform: "none"
                        }}
                        variant="contained"
                      >
                        <BiPlus className={EstilosButton.icon} />
                        <p className={EstilosButton.font}>
                          Agregar{" "}
                          {addLabel ||
                            (permisoCheck === "areas"
                              ? "proyectos"
                              : permisoCheck)}
                        </p>
                      </Button>
                    </NavLink>
                  </div>
                ) : (
                  <div className={EstilosButton.buttonAddDisabled}>
                    <Button
                      disabled
                      sx={{
                        width: "100%",
                        height: "41px",
                        backgroundColor: "#157CC1",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        textTransform: "none"
                      }}
                      variant="contained"
                    >
                      <BiPlus className={EstilosButton.icon} />
                      <p className={EstilosButton.font}>
                        Agregar {permisoCheck}
                      </p>
                    </Button>
                  </div>
                )}
              </Grid>

              {/* CONTENEDOR DE BOTON RELOAD */}
              <Grid
                item
                xs={2}
                sm={filtroCustom != false ? 2 : 1}
                md={1}
                sx={{
                  "@media (max-width: 600px)": {
                    order: "1",
                    paddingLeft: "10px"
                  },
                  "@media (min-width: 600px)": {
                    paddingLeft: "10px",
                    order: "2"
                  },
                  "@media (min-width: 900px)": {
                    order: "3"
                  }
                }}
              >
                <IconButton
                  disabled={loading}
                  onClick={(e) => {
                    getDatos()
                  }}
                  style={{
                    width: "100%",
                    height: "41px",
                    borderRadius: "10px",
                    backgroundColor: "#0FB11F",
                    border: "1px solid #0FB11F",
                    boxShadow:
                      "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"
                  }}
                >
                  <AiOutlineReload
                    style={{
                      color: "#FFFFFF",
                      width: "80%",
                      height: "80%"
                    }}
                  />
                </IconButton>
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={filtroCustom ? 9 : 4}
                sx={{
                  display: "flex",
                  "@media (max-width: 600px)": {
                    marginTop: "12px",
                    order: "3"
                  },
                  "@media (min-width: 600px)": {
                    marginTop: "12px",
                    order: "3"
                  },
                  "@media (min-width: 900px)": {
                    marginTop: "0px",
                    order: "1"
                  }
                }}
              >
                {/* ESTE ES EL VER */}
                <Hidden smDown={!filtroCustom ? true : false}>
                  <Grid
                    item
                    sm={0}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "500",
                      fontSize: "14px",
                      lineHeight: "9.5px",
                      letterSpacing: "7%",
                      color: "#AAAAAA",
                      justifyContent: "center"
                      // "@media (min-width: 1200px)": {
                      //   marginLeft: "10px"
                      // }
                    }}
                  >
                    <div>
                      <p style={{ marginRight: "5px" }}>Ver:</p>
                    </div>
                  </Grid>
                </Hidden>
                {/* ESTE ES EL DE LAS PAGINAS */}
                <Grid
                  item
                  xs={!filtroCustom ? 2 : 3}
                  sm={2}
                  sx={{ marginRight: "10px" }}
                >
                  <SelectFormat
                    value={rowsPerPage}
                    // placeholder={"Ver"}
                    onChange={(e) => {
                      handleChangeRowsPerPage(e)
                    }}
                    datos={[
                      { label: "10", value: 10 },
                      { label: serverPagination ? "20" : "25", value: serverPagination ? 20 : 25 },
                      { label: "50", value: 50 },
                      { label: "100", value: 100 }
                    ]}
                  />
                </Grid>

                {/* ESTE ES EL TEXTO FILTROS */}

                <Hidden smDown={true} mdDown={!filtroCustom ? false : true}>
                  <Grid
                    item
                    sm={1}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "500",
                      fontSize: "14px",
                      lineHeight: "9.5px",
                      letterSpacing: "7%",
                      color: "#AAAAAA",
                      justifyContent: "center",
                      marginRight: "10px",
                      "@media (max-width: 1024px)": {
                        marginLeft: "10px"
                      }
                    }}
                  >
                    <div>{filtroCustom ? <p></p> : <p>Filtros:</p>}</div>
                  </Grid>
                </Hidden>
                {!filtroCustom && buscador}
              </Grid>
              {filtroCustom != false &&
                buscador.map((item, i) => {
                  return item
                })}
            </Grid>
          ) : (
            buscador
          )}

          <div
            className={InventarioStyles.inhabilitArea}
            style={{ height: !seeDisabledOption && "60px" }}
          >
            {seeDisabledOption && (
              <div
                className={InventarioStyles.deshabilitArea}
                style={{ paddingLeft: !seeDisabledOption && "12px" }}
              >
                <Switch
                  checked={showHabilit}
                  onClick={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
                <p className={InventarioStyles.font}>Ver Deshabilitados</p>
              </div>
            )}
            <div
              className={InventarioStyles.dateArea}
              style={{ height: !seeDisabledOption && "100%" }}
            >
              <div className={InventarioStyles.firstDateArea}>
                <div className={InventarioStyles.dateTitleArea}>
                  Fecha inicio
                </div>
                <div className={InventarioStyles.dateTimeArea}>
                  <input
                    type="date"
                    value={busqueda?.fechaInicio}
                    className={InventarioStyles.dateDesing}
                    onChange={(e) => {
                      setBusqueda({
                        ...busqueda,
                        fechaInicio: e.target.value
                      })
                      getDatos({
                        fechaInicio: e.target.value,
                        fechaFinal: busqueda?.fechaFinal
                      })
                    }}
                  />
                </div>
              </div>
              <div className={InventarioStyles.endDateArea}>
                <div className={InventarioStyles.dateTitleArea}>
                  Fecha final
                </div>
                <div className={InventarioStyles.dateTimeArea}>
                  <input
                    type="date"
                    value={busqueda?.fechaFinal}
                    className={InventarioStyles.dateDesing}
                    onChange={(e) => {
                      setBusqueda({
                        ...busqueda,
                        fechaFinal: e.target.value
                      })
                      getDatos({
                        fechaInicio: busqueda?.fechaInicio,
                        fechaFinal: e.target.value
                      })
                    }}
                  />
                </div>
              </div>
              {serverPagination && exportData === null && (
                <Button disabled={loading || exportLoading} onClick={prepareExport}>
                  {exportLoading ? "Preparando…" : "Preparar exportación"}
                </Button>
              )}
              {/* Aqui sera en donde se podra el boton pdf */}
              <div className={InventarioStyles.dateButtonArea}>
                {!loading && filterData(datos) ? (
                  <CarTablePDF onDemand={serverPagination} data={serverPagination ? (exportData || []) : filterData(datos)} dataPdf={dataPdf} />
                ) : (
                  <div className={InventarioStyles.loadingArea}>
                    <CircularProgress />
                  </div>
                )}
              </div>
              <div className={InventarioStyles.dateButtonArea}>
                {!loading && filterData(datos) ? (
                  <TableExcel
                    data={serverPagination ? (exportData || []) : filterData(datos)}
                    permisoCheck={permisoCheck}
                    fechaInicio={busqueda?.fechaInicio}
                    fechaFinal={busqueda?.fechaFinal}
                  />
                ) : (
                  <>
                    <div className={InventarioStyles.loadingArea}>
                      <CircularProgress />
                    </div>
                  </>
                )}
              </div>
              {/* .s*/}
            </div>
          </div>

          <div className={InventarioStyles.tableSpace}>
            {requestError && (
              <Alert severity="error" sx={{ width: "100%", marginBottom: 2 }}>
                {requestError}
              </Alert>
            )}
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              {!loading && filterData(datos) ? (
                <>
                  <TableContainer sx={{}}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          {Object.keys(dataTable).map((column, i) => (
                            <TableCell
                              key={i}
                              sx={{
                                backgroundColor: "#157CC1",
                                height: "46px",
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: "500",
                                fontSize: "12px",
                                lineHeight: "9.5px",
                                color: "white",
                                textAlign: "center"
                              }}
                            >
                              {dataTable[column].nombre}
                            </TableCell>
                          ))}
                          {Actions &&
                            ((permiso[permisoCheck] & 4) === 4 ||
                              (permiso[permisoCheck] & 8) === 8) && (
                              <TableCell
                                sx={{
                                  backgroundColor: "#157CC1",
                                  height: "46px",
                                  fontFamily: "'Poppins', sans-serif",
                                  fontWeight: "500",
                                  fontSize: "12px",
                                  lineHeight: "9.5px",
                                  color: "white",
                                  textAlign: "center"
                                }}
                              >
                                Acciones
                              </TableCell>
                            )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filtrar(
                          verBusqueda.nombre,
                          showHabilit === false
                            ? datosHabilitados
                            : datosDeshabilitados
                        )
                          ?.slice(
                            serverPagination ? 0 : page * rowsPerPage,
                            serverPagination ? rowsPerPage : page * rowsPerPage + rowsPerPage
                          )
                          .map((row, index) => {
                            return (
                              <React.Fragment key={index}>
                                <TableRow
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={index}
                                >
                                  {Object.keys(dataTable).map((column, i) => {
                                    return (
                                      <TableCell
                                        key={i}
                                        sx={{
                                          backgroundColor:
                                            index % 2 ? "#FFFFFF" : "#D9D9D9",
                                          height: "60px",
                                          fontFamily: "'Poppins', sans-serif",
                                          fontWeight: "500",
                                          fontSize: "12px",
                                          lineHeight: "9.5px",
                                          color: "#717171",
                                          textAlign: "center"
                                        }}
                                      >
                                        {dataTable[column].content(row)}
                                      </TableCell>
                                    )
                                  })}

                                  {Actions &&
                                    ((permiso[permisoCheck] & 4) === 4 ||
                                      (permiso[permisoCheck] & 8) === 8) && (
                                      <TableCell
                                        sx={{
                                          backgroundColor:
                                            index % 2 ? "#FFFFFF" : "#D9D9D9",
                                          height: "60px",
                                          fontFamily: "'Poppins', sans-serif",
                                          fontWeight: "500",
                                          fontSize: "12px",
                                          lineHeight: "9.5px",
                                          color: "#717171",
                                          textAlign: "center"
                                        }}
                                      >
                                        <Acciones
                                          permisoCheck={permisoCheck}
                                          recargar={getDatos}
                                          id={row[tipo]}
                                          tipo={tipo}
                                          isEliminado={row.eliminado}
                                          data={row}
                                        />
                                      </TableCell>
                                    )}
                                </TableRow>
                              </React.Fragment>
                            )
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <TablePagination
                    component="div"
                    count={
                      serverPagination ? totalRows : filterData(
                        showHabilit === false
                          ? datosHabilitados
                          : datosDeshabilitados
                      )?.length
                    }
                    rowsPerPageOptions={serverPagination ? [10, 20, 50, 100] : [10, 25, 50, 100]}
                    labelRowsPerPage="Por página"
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelDisplayedRows={({ from, to, count }) => {
                      return `${from}-${to} de ${count} ${permisoCheck}`
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      height: "70px",
                      ".MuiInputBase-root": {
                        display: serverPagination ? "inline-flex" : "none"
                      },
                      ".MuiTablePagination-toolbar": {
                        display: "flex",
                        justifyContent: "center",
                        width: serverPagination ? "auto" : "30%",
                        color: "rgb(41, 39, 39)",
                        height: "35px",
                        ".MuiTablePagination-actions": {
                          marginLeft: "0px"
                        }
                      },
                      ".MuiTablePagination-selectLabel": {
                        display: serverPagination ? "block" : "none"
                      },
                      ".MuiTablePagination-displayedRows": {
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: "500",
                        fontSize: "12px",
                        lineHeight: "9.5px",
                        color: "#717171"
                      },
                      ".css-1psng7p-MuiTablePagination-spacer ": {
                        display: "none"
                      },
                      ".MuiTablePagination-spacer": {
                        padding: "0px"
                      },
                      "@media (min-width: 600px)": {
                        ".MuiTablePagination-toolbar": {
                          padding: "0px"
                        }
                      }
                    }}
                  />
                </>
              ) : (
                <>
                  <div className={InventarioStyles.loadingArea}>
                    <CircularProgress />
                  </div>
                </>
              )}
            </Paper>
          </div>
        </div>
      </div>
    </>
  )
}
